<template>
  <v-dialog v-model="modal" width="640px">
    <v-card>
      <v-card-title>{{ $t('messenger.actions.createappointment.title.default') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step editable :step="1" :complete="step > 1">{{ $t('messenger.actions.createappointment.title.day') }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable :step="2" :complete="step > 2">{{ $t('messenger.actions.createappointment.title.hour') }}</v-stepper-step>
          </v-stepper-header>

          <v-stepper-content :step="1">
            <h4 class="subheading">{{ $t('messenger.actions.createappointment.labels.day') }}</h4>
            <v-date-picker
              v-model="day"
              :allowed-dates="allowedDates"
              :actions="true"
              scrollable
              landscape>
            </v-date-picker>
          </v-stepper-content>

          <v-stepper-content :step="2">
            <h4 class="subheading">{{ $t('messenger.actions.createappointment.labels.hour') }}</h4>
            <v-time-picker
              v-model="hour"
              :actions="true"
              format="24hr"
              scrollable
              landscape>
            </v-time-picker>
          </v-stepper-content>
        </v-stepper>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-row actions>
        <v-btn v-if="step === 1" primary light @click.native="step = 2">{{ $t('messenger.actions.createappointment.next') }}</v-btn>
        <v-btn v-if="step === 2" :loading="loading || callLoading" primary light @click.native.stop="submit()">{{ $t('messenger.actions.createappointment.submit') }}</v-btn>
      </v-card-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import chatMessage from '@/mixins/chatMessage'
  import autoOpenModal from '@/mixins/autoOpenModal'
  export default {
    mixins: [
      autoOpenModal,
      chatMessage
    ],
    data () {
      const currentTime = new Date()
      return {
        step: 1,
        day: this.formatDate(currentTime),
        hour: this.formatHour(currentTime)
      }
    },
    computed: {
      ...mapGetters({
        currentExpert: 'skiliko/session/currentUser',
        platform: 'skiliko/session/currentPlatform',
        callLoading: 'skiliko/call/isLoading'
      }),
      callAtISOString () {
        const [year, month, day] = this.day.split('-')
        const [hour, minutes] = this.hour.split(':')
        const currentDate = new Date(year, month - 1, day, hour, minutes)
        const formattedDate = this.formatDate(currentDate, true)
        const formattedHour = this.formatHour(currentDate, true)
        return `${formattedDate}T${formattedHour}:00.000Z`
      }
    },
    methods: {
      ...mapActions({
        createAppointment: 'skiliko/call/createAppointment'
      }),
      strTime (number) {
        return `0${number}`.substr(-2)
      },
      formatDate (date, utc = false) {
        const x = utc ? 'UTC' : ''
        return [
          date[`get${x}FullYear`](),
          this.strTime(date[`get${x}Month`]() + 1),
          this.strTime(date[`get${x}Date`]())
        ].join('-')
      },
      formatHour (date, utc = false) {
        const x = utc ? 'UTC' : ''
        return [
          this.strTime(date[`get${x}Hours`]()),
          this.strTime(date[`get${x}Minutes`]())
        ].join(':')
      },
      allowedDates (date) {
        return +date >= +new Date()
      },
      content (appointment) {
        return [
          this.$t('messenger.actions.createappointment.message', this.currentExpert),
          [
            this.platform.url,
            'transactions',
            appointment.id
          ].join('/')
        ].join(' ')
      },
      submit () {
        this.createAppointment({
          userId: this.user.externalId,
          adminId: this.currentExpert.id,
          callAt: this.callAtISOString
        })
          .then(appointment => this.send({
            content: this.content(appointment)
          }))
          .then(_ => this.close())
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/messenger/actions/CreateAppointment.vue